import { render, staticRenderFns } from "./PaginationPage.vue?vue&type=template&id=37104dee&"
import script from "./PaginationPage.vue?vue&type=script&lang=js&"
export * from "./PaginationPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports